/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert";

import Slider from 'react-slick';

class MyTopCard extends Component {
  state = {
    slideIndex: 0,
    slidePlay: true,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getCard();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getCard = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      const result = await this._getCardApi();
      const intReturn = result.data[0].intReturn;
      const cash = result.data[0].cash;
      const cardList = result.data[0].listData;
      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            cardList,
            cash,
          });
        }
      }
    }
  };
  _getCardApi = () => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/cardList', {
        params: {
          userid: loginId,
          authId: authId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _onTogglePlay = () => {
    const { slidePlay } = this.state;
    if (slidePlay) {
      this.slider.slickPause();
    } else {
      this.slider.slickPlay();
    }
    this.setState({
      slidePlay: !slidePlay,
    });
  };
  _onPlay = () => {
    this.slider.slickPlay();
  };

  _renderItem = () => {
    const { cardList, cash } = this.state;
    const { imgUrl } = this.props;

    const list = cardList.map((item, index) => {
      return (
        <div style={{ textAlign: 'center' }} key={index}>
          <img
            src={imgUrl + '/img/cashcard/cashcard01.png'}
            style={{ paddingLeft: 45, cursor: 'pointer' }}
            onClick={this._onMyCard}
          />
          <p>{item.cardName}</p>
          <span>현재남은 포인트: {this._CommaFormatted(cash)}포인트</span>
        </div>
      );
    });

    return list;
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onMyCard = () => {
    const { setCardListShow } = this.props;
    setCardListShow(true);
  };
  _onCharge = () => {
    const { history } = this.props;
    history.push('/ticket');
  };
  render() {
    const { cardList } = this.state;
    const { imgUrl } = this.props;

    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 2500,
      className: 'mypage_s_img',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };
    return (
      <Fragment>
        {cardList ? (
          <div className="mypage_s_group">
            <h2 style={{ cursor: 'pointer' }}>
              나의 포인트카드({cardList.length})
              <div className="s_location">
                <div onClick={this._onCharge}>충전하기</div>
                {/*cardList ? (
                                    cardList.map((i, index) => {
                                        //////console.log(index)
                                    return (<span key={index} onClick={()=>this._onGoto(index)} style={{cursor: 'pointer'}} className={slideIndex === index ? "on": null}></span>)
                                    })
                                ) : null*/}
              </div>
            </h2>
            <div className="mypage_s_img" style={{ textAlign: 'center' }}>
              <a style={{ cursor: 'pointer' }} className="pre_btn">
                <img
                  src={imgUrl + '/img/cashcard/pre_btn.png'}
                  onClick={this._onPrev}
                />
              </a>
              <a style={{ cursor: 'pointer' }} className="next_btn">
                <img
                  src={imgUrl + '/img/cashcard/next_btn.png'}
                  onClick={this._onNext}
                />
              </a>

              <Slider ref={(ref) => (this.slider = ref)} {...settings}>
                {cardList ? this._renderItem() : null}
              </Slider>
            </div>
          </div>
        ) : null}

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyTopCard));
